import gql from 'graphql-tag'
import { MileagePriceFragment } from '@/graphql/fragments/vehicle/mileagePrice'

export const mutation = gql`
  ${MileagePriceFragment}
  mutation insertMileagePrice($fields: vehicle_mileage_price_insert_input!) {
    record: insert_vehicle_mileage_price_one(object: $fields) {
      ...MileagePrice
    }
  }
`

export default mutation
